import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d46da80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination d-flex align-items-center justify-content-between p-0 mb-5" }
const _hoisted_2 = { style: {"min-width":"14rem","display":"flex","flex-direction":"column"} }
const _hoisted_3 = { style: {"font-size":"14px"} }
const _hoisted_4 = { style: {"font-size":"14px"} }
const _hoisted_5 = {
  class: "d-flex flex-row align-items-center m-0",
  id: "paginationList"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-left" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex flex-row align-items-center" }
const _hoisted_9 = ["id", "disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick", "id"]
const _hoisted_13 = ["id", "disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-right" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Exibindo " + _toDisplayString(_ctx.itemsOnPage?.length) + " " + _toDisplayString(_ctx.tipo) + ".", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tipo) + ": " + _toDisplayString(_ctx.totalBanco), 1)
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_ctx.state.currentPage > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage(1))),
            title: "Voltar ao inicio",
            id: "startPaginate"
          }, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "",
          id: _ctx.state.currentPage === 1 ? 'btnPaginationOff' : 'btnPagination',
          disabled: _ctx.state.currentPage === 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage - 1)))
        }, _hoisted_11, 8, _hoisted_9),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageCount, (number, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            ((_ctx.state.currentPage < 4 ? key + 1 >= 1 && key + 1 <= 6 : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3) ||
        (_ctx.pageCount - _ctx.state.currentPage < 4
          ? key + 1 >= _ctx.pageCount - 6 && key + 1 <= _ctx.pageCount
          : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3)
        )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.setCurrentPage(number)),
                  class: "cursor-pointer",
                  style: _normalizeStyle([_ctx.state.currentPage > 99? 'padding: 0 25px;': '']),
                  id: number == _ctx.state.currentPage ? 'exibOk' : 'exibRed'
                }, _toDisplayString(number), 13, _hoisted_12))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("button", {
          class: "",
          id: _ctx.state.currentPage === _ctx.pageCount ? 'btnPaginationOff' : 'btnPagination',
          disabled: _ctx.state.currentPage === _ctx.pageCount,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage + 1)))
        }, _hoisted_15, 8, _hoisted_13),
        (_ctx.state.currentPage != _ctx.pageCount)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentPage(_ctx.pageCount))),
              class: "cursor-pointer",
              id: "endPaginate",
              style: {}
            }, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}